<cll-dialog-layout>
    <cll-dialog-header>
        <cll-dialog-title>Edit contact & access details</cll-dialog-title>
        <cll-dialog-subtitle>For {{ client.reference }}</cll-dialog-subtitle>
    </cll-dialog-header>
    <div class="dialog-container">
        <div class="dialog-detail">
            <div class="dialog-container-header">
                <cll-icon type="outlined" [size]="24">account_circle</cll-icon>
                <span class="dialog-container-header-text">Contact & access details</span>
            </div>
            <div>
                <cll-form-field label="Email address">
                    <input cllFormInput
                           [formControl]="clientDetailsFormGroup.controls.email"
                           type="text">
                </cll-form-field>
            </div>

            <div class="phone-numbers-container">
                <span>Phone number</span>
                <form [formGroup]="contactNumbersForm">
                    <div formArrayName="contactNumbers">
                        <div *ngFor="let contactNumberFormGroup of contactNumbersFormArray.controls; let i = index"
                             [formGroupName]="i">
                            <div class="contact-numbers-container">
                                <div>
                                    <cll-form-field label="Contact type">
                                        <select formControlName="type" cllFormInput>
                                            <option value="mobile">Mobile</option>
                                            <option value="landline">Landline</option>
                                            <option value="work">Work</option>
                                            <option value="fax">Fax</option>
                                        </select>
                                    </cll-form-field>
                                </div>
                                <div>
                                    <cll-form-field label="Contact number">
                                        <input cllFormInput formControlName="number" type="text">
                                    </cll-form-field>
                                </div>
                                <div>
                                    <button cll-button class="delete-button" type="button"
                                            (click)="removeContactNumber(i)">
                                        <cll-icon type="outlined" [size]="24">delete</cll-icon>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button cll-outline-button class="add-button" (click)="addContactNumber()">
                        <cll-icon cllButtonIcon>add</cll-icon>
                        Add
                    </button>
                </form>
            </div>

            <div class="address-container">
                <span>Address</span>
                <div class="grid-columns-2">
                    <div>
                        <cll-form-field label="Address line 1">
                            <input cllFormInput
                                   [formControl]="addressFormGroup.controls.street_1"
                                   type="text">
                        </cll-form-field>
                    </div>
                    <div>
                        <cll-form-field label="Address line 2">
                            <input cllFormInput
                                   [formControl]="addressFormGroup.controls.street_2"
                                   type="text">
                        </cll-form-field>
                    </div>
                </div>
                <div class="grid-columns-2">
                    <div>
                        <cll-form-field label="Town/City">
                            <input cllFormInput
                                   [formControl]="addressFormGroup.controls.town"
                                   type="text">
                        </cll-form-field>
                    </div>
                    <div>
                        <cll-form-field label="County">
                            <input cllFormInput
                                   [formControl]="addressFormGroup.controls.county"
                                   type="text">
                        </cll-form-field>
                    </div>
                </div>
                <div class="grid-columns-2">
                    <div>
                        <cll-form-field label="Post code">
                            <input cllFormInput
                                   [formControl]="addressFormGroup.controls.post_code"
                                   type="text">
                        </cll-form-field>
                    </div>
                    <div>
                        <cll-form-field label="Country">
                            <input cllFormInput
                                   [formControl]="addressFormGroup.controls.country"
                                   type="text">
                        </cll-form-field>
                    </div>
                </div>
            </div>

            <div class="comments-container">
                <span>Address additional comments</span>
                <div>
                    <cll-form-field label="">
                        <input cllFormInput placeholder="e.g. What3Words location"
                               [formControl]="addressFormGroup.controls.additional_comments"
                               type="text">
                    </cll-form-field>
                </div>
            </div>
            <div>
                <cll-slide-toggle
                class="p-0"
                [colour]="'secondary'"
                [formControl]="addressFormGroup.controls.hard_to_reach"
                >Is the property hard to reach?</cll-slide-toggle
            >
            </div>
        </div>
    </div>
    <span class="dialog-divider"></span>
    <cll-dialog-footer>

        @if (updateClientRequest.error(); as error) {
            <app-error-panel [error]="error" />
        }

        <button cll-button
                colour="variant"
                cllDialogClose>
            Cancel
        </button>
        <button cll-filled-button
                colour="secondary"
                [disabled]="this.updateClientRequest.loading()"
                (click)="update()">
            Save
        </button>
    </cll-dialog-footer>
</cll-dialog-layout>
